import { FC, useEffect, useState } from "react";
import { ColorPickerItem, ColorPickerWrapper } from "features/hives/ui/hivesNew/styles.ts";

export type ColorPickerProps = {
    items: string[];
    onChange: (color: string) => void;
    initial?: string;
};

const ColorPicker: FC<ColorPickerProps> = ({ items, onChange, initial }) => {
    const [current, setCurrent] = useState<string>(initial ?? items[0]);

    useEffect(() => {
        const next = initial ?? items[0];
        setCurrent(next);
    }, [initial, items]);

    const onClick = (color: string) => {
        if (color === current) return;
        setCurrent(color);
        onChange(color);
    };

    return (
        <ColorPickerWrapper>
            {items.map((e, i) => (
                <ColorPickerItem
                    $color={e}
                    $isActive={e === current}
                    key={i}
                    onClick={() => onClick(e)}
                />
            ))}
        </ColorPickerWrapper>
    );
};

export default ColorPicker;
